import type React from 'react'
import { useEffect, useState } from 'react'
import { Checkbox, Input } from 'antd'

interface EditableCellProps {
  value: number | string | boolean
  onChange: (value: string | boolean) => void
  style?: React.CSSProperties
  inputType?: 'text' | 'checkbox'
}

const EditableCell: React.FC<EditableCellProps> = ({ value, onChange, style, inputType = 'text' }) => {
  const [draft, setDraft] = useState<string>(value === undefined || value === null ? '' : String(value))

  useEffect(() => {
    setDraft(value === undefined || value === null ? '' : String(value))
  }, [value])

  const commit = (next: string): void => {
    if (next.trim() !== String(value ?? '').trim()) {
      onChange(next)
    }
  }

  let inputElement

  if (inputType === 'text') {
    inputElement = (
      <Input
        style={style}
        value={draft}
        onChange={(e) => { setDraft(e.target.value) }}
        onBlur={(e) => { commit(e.target.value) }}
        onPressEnter={(e) => {
          commit((e.target as HTMLInputElement).value)
          ;(e.target as HTMLInputElement).blur()
        }}
      />
    )
  } else if (inputType === 'checkbox') {
    inputElement = (
      <Checkbox
        style={style}
        indeterminate={value === undefined}
        checked={value as boolean}
        onChange={(e) => { onChange(e.target.checked) }}
      />
    )
  }

  return (
    <div style={{ textAlign: 'center' }}>
      {inputElement}
    </div>
  )
}

export default EditableCell
